/**
 * errorHandler creates the window.onerror function.
 *
 * window.onerror displays the JavaScript error in a toast using window.initToast.
 *
 * Dependencies
 * - window.initToast (which uses toastr)
 */

function errorHandler() {
	window.onerror = function(message, url, line, column, error) {
		window.initToast(`Javascript: ${message}`, 'error');
		toggleLoader(false);
	};
}
errorHandler();
